// 仅根据时间搜索

import React, { Component } from 'react';
import { DatePicker, Radio, Form } from 'antd';
import moment from 'moment';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const FormItem = Form.Item;

const currentYear = moment.unix(new Date().getTime() / 1000).format('YYYY');
const yearStartDate = `${currentYear}-01-01`;
const yearEndDate = `${currentYear}-12-31`;
const monthStartDate = moment(moment().startOf('month')).format('YYYY-MM-DD');
const monthEndDate = moment(moment().endOf('month')).format('YYYY-MM-DD');

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    const {
      form: { setFieldsValue },
    } = this.props;
    const { defaultValue = {} } = this.props;
    const { beginDate, endDate } = defaultValue;
    if (beginDate && endDate) {
      this.setTypeByRange(beginDate, endDate);
      setFieldsValue({
        range: [moment(beginDate, 'YYYY-MM-DD'), moment(endDate, 'YYYY-MM-DD')],
      });
    }
  };

  onChangeType = e => {
    const {
      form: { setFieldsValue, resetFields },
    } = this.props;
    const {
      target: { value },
    } = e;
    let start;
    let end;
    if (value === '0') {
      resetFields('range');
      this.props.onChange({
        beginDate: '',
        endDate: '',
      });
      return;
    }
    if (value === '1') {
      start = moment().startOf('month');
      end = moment().endOf('month');
    } else if (value === '2') {
      start = moment().startOf('year');
      end = moment().endOf('year');
    }
    setFieldsValue({
      range: [start, end],
    });
    this.props.onChange({
      beginDate: moment(start).format('YYYY-MM-DD'),
      endDate: moment(end).format('YYYY-MM-DD'),
    });
  };

  onChangeRange = value => {
    const beginDate = value[0] ? moment(value[0]).format('YYYY-MM-DD') : '';
    const endDate = value[1] ? moment(value[1]).format('YYYY-MM-DD') : '';
    this.setTypeByRange(beginDate, endDate);
    this.props.onChange({
      beginDate,
      endDate,
    });
  };

  setTypeByRange = (beginDate, endDate) => {
    const {
      form: { setFieldsValue },
    } = this.props;
    if (beginDate === yearStartDate && endDate === yearEndDate) {
      setFieldsValue({ type: '2' });
    } else if (beginDate === monthStartDate && endDate === monthEndDate) {
      setFieldsValue({ type: '1' });
    } else {
      setFieldsValue({ type: undefined });
    }
  };

  render() {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form style={{ textAlign: 'right' }} layout="inline">
        <FormItem>
          {getFieldDecorator('type')(
            <RadioGroup onChange={this.onChangeType}>
              <RadioButton value="0">全部</RadioButton>
              <RadioButton value="1">本月</RadioButton>
              <RadioButton value="2">本年</RadioButton>
            </RadioGroup>,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('range')(
            <RangePicker style={{ marginLeft: '8px' }} onChange={this.onChangeRange} />,
          )}
        </FormItem>
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/comm/search/DateSearch.js